export const ROLE_NAMES = {
  ["ADMIN_FOUNDER"]: "Administrador fundador",
  ["ADMIN"]: "Administrador",
  ["EDITOR"]: "Editor independiente",
  ["EMPLOYEE"]: "Acceso de empleado",
};
